import adminAccordion from './alpine/admin-accordion';
import album from './alpine/album';
import articleName from './alpine/article-name';
import dateField from './alpine/date-field';
import fileField from './alpine/file-field';
import filterText from './alpine/filter-text';
import flashBanner from './alpine/flash-banner';
import groups from './alpine/groups';
import numberInput from './alpine/number-input';
import userDetail from './alpine/user-detail';

window.alpineComponents = {
  adminAccordion,
  album,
  articleName,
  dateField,
  fileField,
  filterText,
  flashBanner,
  groups,
  numberInput,
  userDetail,
};
